import { stringify } from 'qs';
import request from '../../utils/request';
import func from '../../utils/Func';

export async function querySectionTemplate(params) {
  return request(
    `/api/tscloud-eq-interact/schedule-template/getDetailByCondition?${stringify(params)}`,
  );
}

export async function querySection(params) {
  return request(
    `/api/tscloud-eq-interact/schedule-template-detail/getSectionListByCondition?${stringify(
      params,
    )}`,
  );
}

export async function querySectionList(params) {
  return request(`/api/tscloud-eq-interact/schedule-template-detail/list?${stringify(params)}`);
}

export async function queryWeekList(params) {
  return request(
    `/api/tscloud-eq-interact/schedule-template/getWeekListByCondition?${stringify(params)}`,
  );
}

export async function submit(params) {
  return request(`/api/tscloud-eq-interact/conference/submit`, {
    method: 'POST',
    body: params,
  });
}

export async function remove(params) {
  return request(`/api/tscloud-eq-interact/conference/remove`, {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function copyPrevWeek(params) {
  return request(`/api/tscloud-eq-interact/schedule-template/copyLastWeekConferenceTable`, {
    method: 'POST',
    body: func.toFormData(params),
  });
}
